import React from 'react';

import { FRAGNET_SEARCH_ROLE } from 'common/constants';
import LoginView from 'components/Login';
import { useAuth } from 'hooks';
import { useTranslation } from 'react-i18next';

import { Divider, Popover, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import LockOpenRoundedIcon from '@material-ui/icons/LockOpenRounded';
import LockRoundedIcon from '@material-ui/icons/LockRounded';

interface Props {
  anchorEl: null | HTMLElement;
  isMenuOpen: boolean;
  handleClose: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
    },
    header: {
      display: 'flex',
      justifyContent: 'center',
      gap: theme.spacing(2),
    },
    divider: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  }),
);

const UserMenu = ({ anchorEl, isMenuOpen, handleClose }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { initialized, keycloak, profile, roles } = useAuth();

  return (
    <Popover
      classes={{ paper: classes.paper }}
      keepMounted
      id={'profile-popover'}
      anchorEl={anchorEl}
      open={isMenuOpen}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onClose={handleClose}
    >
      <Typography component="header" className={classes.header} variant="h5" gutterBottom>
        {t('profile')}
        {keycloak.authenticated ? <LockOpenRoundedIcon /> : <LockRoundedIcon />}
      </Typography>

      <Typography>
        {t('greeting')} <b>{profile?.username}</b>
      </Typography>

      {initialized ? (
        roles?.includes(FRAGNET_SEARCH_ROLE) ? (
          <Typography gutterBottom>{t('can_access')}</Typography>
        ) : (
          <Typography gutterBottom>{t('no_access')}</Typography>
        )
      ) : (
        <Typography>{t('loading')}</Typography>
      )}

      <LoginView />

      <Divider className={classes.divider} />

      <Typography>{`${t('app_version')}: ${process.env.REACT_APP_VERSION}`}</Typography>
    </Popover>
  );
};

export default UserMenu;
